import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OperationFilter } from '@app/models';
import { Observable } from 'rxjs';
import { BaseServiceClass } from '../baseService.service';

@Injectable({ providedIn: 'root' })
export class SegmentServiceV2 extends BaseServiceClass<any> {
  constructor(protected httpService: HttpClient) {
    super(httpService, '/api/v2/segments');
  }

  public filterOperations(
    segmentId: number,
    operationFilter: OperationFilter
  ): Observable<any> {
    return this.httpService.get<any>(
      `${this.entity_url}/${segmentId}/operations`,
      { params: operationFilter as any }
    );
  }

  public addOperation(segmentId: number, operationId: number): Observable<any> {
    return this.httpService.patch<any>(
      `${this.entity_url}/${segmentId}/operations/${operationId}`,
      null
    );
  }

  public findUsersBySegmentAndOperation(
    segmentId: number,
    operationId: number,
    params?: any
  ): Observable<any> {
    return this.httpService.get<any>(
      `${this.entity_url}/${segmentId}/operations/${operationId}/users`,
      { params }
    );
  }

  public findUsersNotInSegmentAndOperation(
    segmentId: number,
    operationId: number,
    params?: any
  ): Observable<any> {
    return this.httpService.get<any>(
      `${this.entity_url}/${segmentId}/operations/${operationId}/users/available`,
      { params }
    );
  }
}
